'use strict';

import React from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { appSelectors, appOperations } from '@/state/domains/app';

export default connect(
	(state, props) => ({
	}),
	{
		setModalOpen: appOperations.setModalOpen,
	}
)(
	({ setModalOpen }) => (
		<div
			onClick={ () => setModalOpen('importJobs') }
		>
			<FontAwesomeIcon icon='upload' color='#444'/>
		</div>
	)
);
